import antdData from 'antd/lib/locale-provider/fr_FR'
import localeData from 'react-intl/locale-data/fr'

const messages = {
  'topBar.issuesHistory': 'Histoire des problèmes',
  'topBar.projectManagement': 'Gestion de projet',
  'topBar.typeToSearch': 'Chercher...',
  'topBar.buyNow': 'Acheter $26',
  'topBar.bitcoin': 'Bitcoin',
  'topBar.profileMenu.hello': 'Bonjour',
  'topBar.profileMenu.billingPlan': 'Plan de facturation',
  'topBar.profileMenu.role': 'Rôle',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Téléphone',
  'topBar.profileMenu.editProfile': 'Editer le profil',
  'topBar.profileMenu.logout': 'Connectez - Out',
}

export default {
  locale: 'fr-FR',
  antdData,
  localeData,
  messages,
}
